/* eslint-disable max-lines-per-function */
import React, { useRef } from 'react';
import { Formik } from 'formik';
import { Growl } from 'primereact/growl';
import { initialValues } from '../helpers/valoresIniciais';
import { validacaoFormImagens } from '../helpers/validacao';
import TvService from '../../../../services/tvs/TvService';
import { FormCadastrarTv } from '../components/formCadastroTV';
import { excludeNull } from '../function/excludeNull';
import { mostrarMensagemSucesso, mostrarMensagemErro } from '../../shared/getMensagens';

export function CadastrarTV({ setRecarregarDataTable, setOpenModalCadastro }) {
    const mensagemToast = useRef(null);

    const cadastrarTv = async (dadosForm, { resetForm }) => {
        try {
            const dados = excludeNull(dadosForm);

            const segundo = 1000;

            await TvService.criaTV(dados);

            mostrarMensagemSucesso(mensagemToast,'Televisor cadastrado com sucesso!');
            resetForm(initialValues);
            setRecarregarDataTable(true);
            setTimeout( () => setOpenModalCadastro(false), segundo) ;
        } catch (error) {
            mostrarMensagemErro(mensagemToast,'Erro ao cadastrar.');
            throw new Error(error);
        }
    };

    return (
        <div>
            <Growl ref={mensagemToast} />
            <Formik
                initialValues={initialValues}
                validationSchema={validacaoFormImagens}
                onSubmit={cadastrarTv}    >

                <FormCadastrarTv nomebotao={'Cadastrar'}></FormCadastrarTv>
            </Formik>
        </div>
    );
}
